import React from "react";
import {Timeline,DatePicker, Modal} from "antd";

const { RangePicker } = DatePicker;

export class DispatchHistory extends React.Component {
  render() {
    return (
      <Modal closable={false} className="create-quote-btn" centered
        visible={this.props.visible} okText="Ok"
        onOk={this.props.onCancel}
        onCancel={this.props.onCancel} width="70%" destroyOnClose={true}>
        <div className="row m-0">
          <div className="col-sm-6 col-12 view-modal-header">
            <h3><span>Dispatch History</span></h3>
          </div>
          <div className="col-sm-6 col-12 view-modal-header text-right">
            <RangePicker/>
          </div>
          <div className="col-12">
            <Timeline>
              <Timeline.Item>
                <div className="row history-list">
                  <div className="col-sm-2 col-4">
                    <p>13-04-2019</p>
                  </div>
                  <div className="col-sm-10 col-8">
                  <ul>
                    <li className="view-timline-detail"><i className="fa fa-eye" /></li>
                    <li><span>Work Order#</span> 246520</li>
                    <li><span>Created Date</span> 01-09-2019</li>
                    <li><span>Dispatched</span> Demo</li>
                  </ul>
                  </div>
                </div>
              </Timeline.Item>
              <Timeline.Item>
                <div className="row history-list">
                  <div className="col-sm-2 col-4">
                    <p>13-04-2019</p>
                  </div>
                  <div className="col-sm-10 col-8">
                  <ul>
                    <li className="view-timline-detail"><i className="fa fa-eye" /></li>
                    <li><span>Work Order#</span> 246520</li>
                    <li><span>Created Date</span> 01-09-2019</li>
                    <li><span>Dispatched</span> Demo</li>
                  </ul>
                  </div>
                </div>
              </Timeline.Item>
              <Timeline.Item>
                <div className="row history-list">
                  <div className="col-sm-2 col-4">
                    <p>13-04-2019</p>
                  </div>
                  <div className="col-sm-10 col-8">
                  <ul>
                    <li className="view-timline-detail"><i className="fa fa-eye" /></li>
                    <li><span>Work Order#</span> 246520</li>
                    <li><span>Created Date</span> 01-09-2019</li>
                    <li><span>Dispatched</span> Demo</li>
                  </ul>
                  </div>
                </div>
              </Timeline.Item>
              <Timeline.Item>
                <div className="row history-list">
                  <div className="col-sm-2 col-4">
                    <p>13-04-2019</p>
                  </div>
                  <div className="col-sm-10 col-8">
                  <ul>
                    <li className="view-timline-detail"><i className="fa fa-eye" /></li>
                    <li><span>Work Order#</span> 246520</li>
                    <li><span>Created Date</span> 01-09-2019</li>
                    <li><span>Dispatched</span> Demo</li>
                  </ul>
                  </div>
                </div>
              </Timeline.Item>
            </Timeline>
          </div>
        </div>
      </Modal>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/account/popups/DispatchHistory.jsx